import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

// Single source of HelmetProvider: every <Helmet> in the app must render
// INSIDE this component, so no consumer needs to know about providers.
const HelmetWrapper = ({ title, description, canonical, jsonLd, children }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        {description ? <meta name="description" content={description} /> : null}
        {canonical ? <link rel="canonical" href={canonical} /> : null}
        {description ? <meta property="og:description" content={description} /> : null}
        {title ? <meta property="og:title" content={title} /> : null}
        {canonical ? <meta property="og:url" content={canonical} /> : null}
        {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
      </Helmet>
      {children}
    </HelmetProvider>
  );
};

export default HelmetWrapper;
